import React from "react";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import AssetInputOrUploadSection from "./AssetInputOrUploadSection";
import { CREATIVE_NAMES, DISPLAY_PARALLAX_AD_FIELDS } from "./definitions";
import InputTextSection from "./InputTextSection";
import BaseCreativeControls from "./BaseCreativeControls";
import { InputSwitch } from "primereact/inputswitch";

const CREATIVE_TYPE = CREATIVE_NAMES.DISPLAY_PARALLAX;

const switchSectionStyles = css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1em;
    .label {
        flex-basis: 80%;
    }
`

export default function ParallaxDisplay({
    desktopCreativeURL,
    container,
    handleChange,
    currentCustomer,
    mobileTopOffset,
    topOffset,
    bottomOffset,
    impressionTag,
    clickTag,
    adServingType,
    showLabels,
    zindex,
    delayExec
}) {
    return (
        <>
            <BaseCreativeControls
                adServingType={adServingType}
                changeHandler={handleChange}
                clickTag={clickTag}
                creativeType={CREATIVE_TYPE}
                impressionTag={impressionTag}
            >
                <div css={switchSectionStyles}>
                    <span className="label">
                        <p><b>Render when DOM ready</b></p>
                    </span>
                    <InputSwitch
                        checked={!!delayExec}
                        name={DISPLAY_PARALLAX_AD_FIELDS.delayExec}
                        onChange={e => {
                            handleChange(e, e.value, CREATIVE_TYPE)
                        }}
                    />
                </div>
                <div css={switchSectionStyles}>
                    <span className="label">
                        <p><b>Show advertisement labels (mobile only)</b></p>
                    </span>
                    <InputSwitch
                        checked={showLabels}
                        name={DISPLAY_PARALLAX_AD_FIELDS.showLabels}
                        onChange={e => {
                            handleChange(e, e.value, CREATIVE_TYPE)
                        }}
                    />
                </div>
                <AssetInputOrUploadSection
                    inputValue={desktopCreativeURL}
                    inputLabel="Image creative Url"
                    inputName={DISPLAY_PARALLAX_AD_FIELDS.desktopCreativeURL}
                    inputChangeHandler={handleChange}
                    inputAdtype={CREATIVE_TYPE}
                    isRequired={true}
                    currentCustomer={currentCustomer}
                    accept="image/*"
                    defaultExtension="jpeg"
                />
                <InputTextSection
                    label={"Container CSS selector"}
                    name={DISPLAY_PARALLAX_AD_FIELDS.container}
                    value={container}
                    changeHandler={handleChange}
                    adtype={CREATIVE_TYPE}
                    required={true}
                    uriEncodeValue={false}
                />
                <InputTextSection
                    label="Top offset (px)"
                    name={DISPLAY_PARALLAX_AD_FIELDS.topOffset}
                    value={topOffset}
                    changeHandler={handleChange}
                    adtype={CREATIVE_TYPE}
                    required={false}
                    isNumericInput={true}
                />
                <InputTextSection
                    label="Mobile top offset (px)"
                    name={DISPLAY_PARALLAX_AD_FIELDS.mobileTopOffset}
                    value={mobileTopOffset}
                    changeHandler={handleChange}
                    adtype={CREATIVE_TYPE}
                    required={false}
                    isNumericInput={true}
                />
                <InputTextSection
                    label="Bottom offset (px)"
                    name={DISPLAY_PARALLAX_AD_FIELDS.bottomOffset}
                    value={bottomOffset}
                    changeHandler={handleChange}
                    adtype={CREATIVE_TYPE}
                    required={false}
                    isNumericInput={true}
                />
                <InputTextSection
                    label="zindex (integer)"
                    name={DISPLAY_PARALLAX_AD_FIELDS.zindex}
                    value={zindex}
                    changeHandler={handleChange}
                    adtype={CREATIVE_TYPE}
                    required={false}
                    isNumericInput={true}
                />
            </BaseCreativeControls>


        </>
    );
}
